import React from "react"
import PropTypes from "prop-types"
import { Spinner } from "reactstrap"

const MESES = [
  { value: 1, label: "Enero" }, { value: 2, label: "Febrero" }, { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" }, { value: 5, label: "Mayo" }, { value: 6, label: "Junio" },
  { value: 7, label: "Julio" }, { value: 8, label: "Agosto" }, { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" }, { value: 11, label: "Noviembre" }, { value: 12, label: "Diciembre" },
]

const ahora = new Date()
const ANIOS = Array.from({ length: 6 }, (_, i) => ahora.getFullYear() - i)

const labelStyle = { fontSize: 12, fontWeight: 600, color: "#475569", textTransform: "uppercase", letterSpacing: 0.4, marginBottom: 6 }
const inputBase = { fontSize: 13, padding: "6px 10px", borderRadius: 6, border: "1px solid #cbd5e1", background: "#fff", height: 34 }

const ToggleModo = ({ modo, onChange }) => (
  <div style={{ display: "inline-flex", borderRadius: 8, background: "#f1f5f9", padding: 3 }}>
    {["mes", "rango"].map(m => (
      <button
        key={m} type="button" onClick={() => onChange(m)}
        style={{
          padding: "6px 16px", border: "none",
          background: modo === m ? "#fff" : "transparent",
          color: modo === m ? "#0f172a" : "#64748b",
          fontWeight: 600, fontSize: 13, borderRadius: 6, cursor: "pointer",
          boxShadow: modo === m ? "0 1px 3px rgba(0,0,0,0.08)" : "none",
        }}
      >
        {m === "mes" ? "Por mes" : "Por rango"}
      </button>
    ))}
  </div>
)
ToggleModo.propTypes = { modo: PropTypes.string, onChange: PropTypes.func }

const HeaderFiltros = ({
  modo, setModo,
  year, setYear, month, setMonth,
  fechaInicio, setFechaInicio, fechaFin, setFechaFin,
  loading, onConsultar, puedeConsultar,
}) => (
  <div className="d-flex flex-wrap align-items-end gap-3">
    <div>
      <div style={labelStyle}>Modo</div>
      <ToggleModo modo={modo} onChange={setModo} />
    </div>

    {modo === "mes" ? (
      <>
        <div>
          <div style={labelStyle}>Mes</div>
          <select style={{ ...inputBase, minWidth: 130 }} value={month} onChange={e => setMonth(Number(e.target.value))}>
            {MESES.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
          </select>
        </div>
        <div>
          <div style={labelStyle}>Año</div>
          <select style={{ ...inputBase, minWidth: 100 }} value={year} onChange={e => setYear(Number(e.target.value))}>
            {ANIOS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </>
    ) : (
      <>
        <div>
          <div style={labelStyle}>Desde <span style={{ color: "#dc2626" }}>*</span></div>
          <input type="date" style={{ ...inputBase, minWidth: 150 }}
            value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} max={fechaFin || undefined} />
        </div>
        <div>
          <div style={labelStyle}>Hasta <span style={{ color: "#dc2626" }}>*</span></div>
          <input type="date" style={{ ...inputBase, minWidth: 150 }}
            value={fechaFin} onChange={e => setFechaFin(e.target.value)} min={fechaInicio || undefined} />
        </div>
      </>
    )}

    <button type="button" className="btn btn-primary"
      onClick={onConsultar} disabled={!puedeConsultar || loading}
      style={{ minWidth: 130, height: 34, padding: "0 16px", fontSize: 13, fontWeight: 600 }}>
      {loading ? (
        <><Spinner size="sm" className="me-2" /> Consultando…</>
      ) : (
        <><i className="mdi mdi-magnify me-1" /> Consultar</>
      )}
    </button>
  </div>
)

HeaderFiltros.propTypes = {
  modo: PropTypes.string.isRequired, setModo: PropTypes.func.isRequired,
  year: PropTypes.number.isRequired, setYear: PropTypes.func.isRequired,
  month: PropTypes.number.isRequired, setMonth: PropTypes.func.isRequired,
  fechaInicio: PropTypes.string.isRequired, setFechaInicio: PropTypes.func.isRequired,
  fechaFin: PropTypes.string.isRequired, setFechaFin: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  onConsultar: PropTypes.func.isRequired,
  puedeConsultar: PropTypes.bool,
}

export default HeaderFiltros
